/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";
import {gsap} from "gsap";
let imagesLoaded = require('imagesloaded');

console.log('JS loaded');

let nav = document.getElementById("mainNav");
document.addEventListener('DOMContentLoaded', function () {
    console.log('Init Scripts');

    function targetBlank() {
        // remove subdomain of current site's url and setup regex
        var internal = location.host.replace("www.", "");
        internal = new RegExp(internal, "i");

        var a = document.getElementsByTagName('a'); // then, grab every link on the page
        for (var i = 0; i < a.length; i++) {
            var href = a[i].host; // set the host of each link
            if (!internal.test(href) || /\.pdf$/.test(a[i].getAttribute("href"))) { // make sure the href doesn't contain current site's host
                a[i].setAttribute('target', '_blank'); // if it doesn't, set attributes
            }
        }
    }
    targetBlank()

    // navbar shrink
    window.addEventListener("scroll", function () {

        if (window.scrollY > 100) {
            nav.classList.add("shrink");
        } else {
            nav.classList.remove("shrink");
        }
    });
    imagesLoaded(document.querySelector("body"), function (instance) {
        // fadein main

        var tlinit = gsap.timeline({
            onComplete: function () {
                //console.log('complete');
                $('.loader').hide();
            }
        });

        tlinit.to('.loader', {
            opacity: 0,
            duration: 0.050
        }, '+=0');


        tlinit.to('main', {
            opacity: 1,
            duration: 0.250
        }, '+=0.10');
        tlinit.to('footer', {
            opacity: 1,
            duration: 0.550
        }, '+=0');
    });

});

